import React from 'react';
import { useAccordionContext } from './hooks';

export type AccordionCollapseType = {
    element?: React.ElementType;
    eventKey?: string | number;
    children?: React.ReactNode | React.ReactNode[];
    extraClass?: string;
    contentId: string;
};

const AccordionCollapse: React.FC<AccordionCollapseType> = ({
    element: Component = 'div',
    eventKey,
    extraClass,
    children,
    contentId,
}) => {
    const { activeEventKey } = useAccordionContext();

    return activeEventKey === eventKey ? (
        <Component className={extraClass} contentId={contentId}>
            {children}
        </Component>
    ) : null;
};

export default AccordionCollapse;
